<app-food-list title="My Food" i18n-title="@@MyFood" [publicOnly]="false" [readonly]="false">
</app-food-list>
<!-- <app-food-list title="Public Foods" i18n-title="@@PublicFoods" [publicOnly]="true" [readonly]="true">
</app-food-list> -->
